export { HorizontalStackedBarChartComponent } from './horizontal-stacked-bar-chart.component';
export { type StackedBarChartItem } from './horizontal-stacked-bar-chart.model';
